import { SignUpState } from './signUp.types'

const initialState: SignUpState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
